export const INFOHUB_BANNER_NEW_COPY = 'Please switch to InfoHub, Spotlight is going away soon!';

export const INFOHUB_HEADER_OLD_COPY = 'Try out InfoHub, the new and improved Spotlight!';

export const INFOHUB_SPOTLIGHT_OUT_OF_SERVICE_COPY = 'Please switch to InfoHub, Spotlight is no longer in service!';

export const getDeprecationWarningBannerMessage = (title, useNewCopy) =>
  useNewCopy ? INFOHUB_BANNER_NEW_COPY : `${title} is going away soon. Click here to go to InfoHub.`;

/** Redirect banners are for removed sections; always use section-specific hide copy. */
export const getInfoHubRedirectBannerMessage = (title) =>
  `${title} is no longer available. Click here to go to InfoHub.`;

/**
 * Yellow header bar copy:
 * 1. Default — legacy promo (no flags)
 * 2. `spotlight_leaving_soon_banner_copy` — going-away message for everyone
 * 3. Hide-search flags — same out-of-service line for general users or admins (Admin / Admin Dev)
 */
export const getHeaderInfoHubBannerMessage = ({ bannerNewCopy = false, searchDisabled = false } = {}) => {
  if (searchDisabled) {
    return INFOHUB_SPOTLIGHT_OUT_OF_SERVICE_COPY;
  }
  if (bannerNewCopy) {
    return INFOHUB_BANNER_NEW_COPY;
  }
  return INFOHUB_HEADER_OLD_COPY;
};
